import React, { useEffect, useState } from "react";
import axios from "axios";
import Hero from "../components/hero/Hero";
import About from "../components/about/About";
import Menus from "../components/menus/Menus";
import OpeningHours from "../components/openinghours/OpeningHours";
import ContactForm from "../components/contactform/ContactForm";
import Map from "../components/map/map";
import Photos from "../components/photos/photos";

import { useLocation } from "react-router-dom";

const Home = () => {
    const { hash } = useLocation();
    const [popup, setPopup] = useState(null);
    const [showPopup, setShowPopup] = useState(false);
    const [imageDimensions, setImageDimensions] = useState({
        width: 0,
        height: 0,
    });

    useEffect(() => {
        async function fetchPopup() {
            try {
                const res = await axios.get("/api/public/popups/active/latest");
                if (res.data && res.data._id) {
                    setPopup(res.data);
                    setShowPopup(true);
                    if (res.data.type === "image") {
                        const img = new window.Image();
                        img.onload = function () {
                            setImageDimensions({
                                width: img.naturalWidth,
                                height: img.naturalHeight,
                            });
                        };
                        img.src = `/api/public/popups/${res.data._id}/image`;
                    }
                }
            } catch (e) {
                setShowPopup(false);
            }
        }
        fetchPopup();
    }, []);

    useEffect(() => {
        if (hash) {
            const element = document.getElementById(hash.replace("#", ""));
            if (element) {
                element.scrollIntoView({ behavior: "smooth" });
            }
        }
    }, [hash]);

    return (
        <>
            {showPopup && popup && (
                <div
                    className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40"
                    onClick={() => setShowPopup(false)}
                >
                    {popup.type === "text" ? (
                        <div
                            className="bg-white rounded-2xl shadow-2xl p-8 max-w-sm w-full text-left cursor-pointer border-2"
                            style={{
                                fontFamily: "'Playfair Display', serif",
                                boxShadow:
                                    "0 8px 32px 0 rgba(31, 38, 135, 0.37)",
                            }}
                            onClick={() => setShowPopup(false)}
                        >
                            <p
                                className="text-xl mb-2 text-black drop-shadow-sm tracking-wide"
                                style={{
                                    fontFamily: "'Playfair Display', serif",
                                }}
                            >
                                {popup.text}
                            </p>
                        </div>
                    ) : (
                        (() => {
                            // Responsive maxWidth: 1/3 auf Desktop, 80% auf Mobile, immer korrektes Seitenverhältnis
                            let screenW = window.innerWidth;
                            let screenH = window.innerHeight;
                            let maxW =
                                screenW >= 768 ? screenW / 3 : screenW * 0.9;
                            let maxH = screenH * 0.9;
                            let width = imageDimensions.width;
                            let height = imageDimensions.height;
                            if (width && height) {
                                const ratio = width / height;
                                // Berechne die größtmögliche Box, die in maxW x maxH passt und das Seitenverhältnis hält
                                let displayW = maxW;
                                let displayH = displayW / ratio;
                                if (displayH > maxH) {
                                    displayH = maxH;
                                    displayW = displayH * ratio;
                                }
                                return (
                                    <div
                                        className="rounded-2xl shadow-2xl flex items-center justify-center overflow-hidden cursor-pointer"
                                        style={{
                                            padding: 0,
                                            width: displayW,
                                            height: displayH,
                                            maxWidth: maxW,
                                            maxHeight: maxH,
                                            aspectRatio: `${width} / ${height}`,
                                        }}
                                        onClick={() => setShowPopup(false)}
                                    >
                                        <img
                                            src={`/api/public/popups/${popup._id}/image`}
                                            alt="Popup"
                                            className="w-full h-full object-contain object-center"
                                            style={{
                                                display: "block",
                                                opacity: 1,
                                            }}
                                        />
                                    </div>
                                );
                            } else {
                                // Fallback für noch nicht geladene Dimensionen
                                return (
                                    <div
                                        className="rounded-2xl shadow-2xl flex items-center justify-center overflow-hidden cursor-pointer w-[80vw] h-[60vw] md:w-[33vw] md:h-[22vw]"
                                        onClick={() => setShowPopup(false)}
                                    >
                                        <img
                                            src={`/api/public/popups/${popup._id}/image`}
                                            alt="Popup"
                                            className="w-full h-full object-contain object-center"
                                            style={{
                                                display: "block",
                                                opacity: 1,
                                            }}
                                        />
                                    </div>
                                );
                            }
                        })()
                    )}
                </div>
            )}
            <Hero />
            <About />
            <Photos />
            <Menus />
            <OpeningHours />
            <ContactForm />
            <Map />
        </>
    );
};

export default Home;
